import React, { useEffect } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "./SessionExpired.css";
/*istanbul ignore next */
const SessionExpired = () => {
  useEffect(() => {
    // Get error message from sessionStorage
    const storedError = sessionStorage.getItem("sessionExpiredError");
    if (storedError) {
      sessionStorage.removeItem("sessionExpiredError");
    }
  }, []);

  return (
    <div className="session-expired-container">
      <div className="session-expired-content">
        <div className="expired-icon-wrapper">
          <ErrorOutlineIcon className="expired-icon" />
        </div>
        <h1>Session Expired</h1>
        <p className="expired-message">
          {"Your session has expired, or you have logged into another device."}
        </p>
        <div className="expired-details">
          <p>This may have happened because:</p>
          <ul>
            <li>You've been inactive for too long</li>
            <li>You logged in from another device</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
